<template>
  <div class="modalContainer">
    <div class="modalOpenTarget" @click="()=>{this.modalOpen = true}">
        <!-- slot for content that when clicked will open the modal -->
      <slot name="modalOpenContent">Open</slot>
    </div>
    <transition name="modal-fade">
      <Modal @close="closeModal" v-if="modalOpen">
          <!-- Slot for content to fill the modal -->
        <slot name="modalContent">
          No Content
        </slot>
      </Modal>
    </transition>
  </div>
</template>

<script>
import Modal from "./Modal";

export default {
  name: "ModalContainer",
  components: {
    Modal
  },
  data() {
    return {
      modalOpen: false
    };
  },
  methods: {
    closeModal() {
      this.modalOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-fade-leave-active {
  transition: all 0.3s ease;
}

.modal-fade-enter-active {
  transition: all 0.5s ease;
  //   transition-delay: 0.3s;
}
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modalOpenTarget{
    cursor:pointer;
}
// .modal-fade{
//     transition: all 1s;
// }
// .modal-fade-enter, .modal-fade-leave-to{
//     transform: scale(0)
// }

// .modal-fade-leave-active, .modal-fade-enter-active {
//   transition: all 200ms ease-in;
// //   position: absolute;
// //   z-index: 0;
// }
</style>
